import useBreakpointContext from '.';
import { breakpointKeys } from './breakpoints';
const useIsMinBreakpoint = (breakpoint) => {
    const currentBreakpointContext = useBreakpointContext();
    return (!!currentBreakpointContext &&
        breakpointKeys.indexOf(currentBreakpointContext.breakpoint) <=
            breakpointKeys.indexOf(breakpoint));
};
export default useIsMinBreakpoint;
//# sourceMappingURL=useIsMinBreakpoint.js.map